<template>
    <div v-if="authenticated">
        <div class="row">
            <div class="col-md-6 col-lg-3 mb-3">
                <button v-if="!unfinishedReport" class="btn btn-orange btn-block" type="button" @click="createReport">
                    Rozpocznij pracę
                </button>
                <button v-else-if="!forgotten" class="btn btn-blue btn-block" type="button" @click="finishReport">
                    Zakończ pracę
                </button>
                <vs-tooltip v-else text="Nie można dodać raportu na więcej niż jeden dzień.">
                    <button class="btn btn-blue btn-block disabled" type="button">
                        Zakończ pracę
                    </button>
                </vs-tooltip>
            </div>
            <div class="col-md-6 col-lg-3">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <vs-tooltip text="Miejsce pracy">
                            <span class="input-group-text"><i class="material-icons">place</i></span>
                        </vs-tooltip>
                    </div>
                    <div v-if="unfinishedReport" class="form-control">
                        {{ placeName }}
                    </div>
                    <select v-else class="form-control" ref="select-place" v-model="placeName">
                        <option v-for="place in places">{{place.name}}</option>
                    </select>
                </div>
            </div>
            <template v-if="unfinishedReport">
                <div class="col-md-6 col-lg-3">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <vs-tooltip text="Czas rozpoczęcia pracy">
                                <span class="input-group-text"><i class="material-icons">access_time</i></span>
                            </vs-tooltip>
                        </div>
                        <div class="form-control">
                            {{ getStartTimeString() }}
                            <template v-if="forgotten">
                                ({{ dayToYYYYMMDD(unfinishedReport.on_date) }})
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <vs-tooltip text="Przepracowany czas">
                                <span class="input-group-text"><i class="material-icons">timer</i></span>
                            </vs-tooltip>
                        </div>
                        <div class="form-control">
                            {{ displayElapsedTime() }}
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import {backend} from '../../backend.js';
    import Constants from '../../constants.js';

    const NOTIFY_LONG_TIME = Constants.get('NOTIFY_LONG_TIME');

    export default {
        name: "ReportWorkButton",
        data() {
            return {
                places: null,
                placeName: null,
                plans: null,
            }
        },
        props: {
            reloadFlag: Boolean,
        },
        created: function() {
            this.$store.dispatch('ia/places')
                .then(data => {
                    this.places = data;
                    this.placeName = this.unfinishedReport ? this.getPlaceName(this.unfinishedReport)
                                                           : Constants.get('IA_REPORT_BUTTON_DEFAULT_PLACE');
                })
                .catch(() => {
                    this.$vs.notify({text: 'Nie udało się pobrać listy miejsc.', color: 'danger'});
                });
            backend.getWorktimePlan({
                    username: this.$store.getters['auth/username'],
                    week_day: moment().isoWeekday(),
                    week_excluded: this.getWeekIdToExclude(),
                    ordering: 'from_hour',
                })
                .then(response => {
                    this.plans = response.data;
                    this.placeName = this.unfinishedReport ? this.getPlaceName(this.unfinishedReport)
                                                           : this.getPlaceNameFromPlan();
                })
        },
        watch: {
            unfinishedReport(newVal) {
                this.placeName = newVal ? this.getPlaceName(newVal) : this.placeName;
            },
        },
        computed: {
            authenticated() {
                return this.$store.getters['auth/authenticated'];
            },
            forgotten() {
                return this.unfinishedReport && this.spansMoreThanOneDay();
            },
            unfinishedReport() {
                return this.$store.getters['ia/currentReport'];
            },
            elapsedTime() {
                return this.$store.getters['ia/workingTimeMinutes'];
            },
        },
        methods: {
            minutesToHours: minutes => Math.floor(minutes / 60) + ' h ' + minutes % 60 + ' min',
            minutesToHHMM: minutes => moment().startOf('day').add(minutes, 'minutes').format('HH:mm'),
            dayToYYYYMMDD: day => moment(day).format('DD.MM.YYYY'),
            getWeekIdToExclude() {
                let EVEN = 2;
                let ODD = 3;
                return (moment().week() % 2 == 0) ? ODD : EVEN;
            },
            getPlaceName(report) {
                return this.places.find(el => el.id === report.place).name;
            },
            getPlaceNameFromPlan() {
                if (this.plans === null || this.plans.length === 0)
                    return Constants.get('IA_REPORT_BUTTON_DEFAULT_PLACE');
                let now = this.getTime();
                let plan = this.plans.find(el => el.from_hour <= now && now <= el.to_hour) ||
                           this.plans.find(el => now < el.from_hour) ||
                           this.plans[this.plans.length - 1];
                return this.places.find(el => el.id === plan.place).name;
            },
            getTime() {
                let date = new Date();
                return date.getHours() * 60 + date.getMinutes();
            },
            spansMoreThanOneDay() {
                return moment().add(-this.elapsedTime, 'minutes') < moment().startOf('day');
            },
            getStartTime() {
                return moment(this.unfinishedReport.on_date).startOf('day').add(this.unfinishedReport.from_hour, 'minutes');
            },
            getStartTimeString() {
                return this.getStartTime().format('HH:mm');
            },
            getTimeString(timeString, exceeded) {
                return this.spansMoreThanOneDay() ? exceeded : timeString;
            },
            displayElapsedTime() {
                let time = this.$store.getters['ia/workingTimeMoment'];
                let hours = time.hours();
                let minutes = time.minutes();
                let timeString = hours > 0
                        ? hours + ' h ' + minutes + ' min'
                        : minutes + ' min';
                return this.getTimeString(timeString, 'ponad 1 dzień');
            },
            getFinishSuccessText(report) {
                const timeElapsed = this.minutesToHours(report.to_hour - report.from_hour);
                return 'Utworzono raport na <b>' + this.dayToYYYYMMDD(report.on_date) + '</b>' +
                    ', godz. <b>' + this.minutesToHHMM(report.from_hour) +
                    ' – ' + this.minutesToHHMM(report.to_hour) + '</b>' +
                    ', przepracowany czas: <b>' + timeElapsed + '</b>.';
            },
            getCreateSuccessText(report) {
                return 'Zaczęto pracę w dniu <b>' + this.dayToYYYYMMDD(report.on_date) + '</b>' +
                    ' o godz. <b>' + this.minutesToHHMM(report.from_hour) + '</b>.';
            },
            getErrorText: (error, def) => {
                const refreshText = error.response.data['should_refresh'] ? ' Spróbuj odświeżyć stronę.' : '';
                return error.response.data['msg'] ? error.response.data['msg'] + refreshText : def;
            },

            finishReport() {
                if (this.spansMoreThanOneDay()) {
                    this.$vs.notify({
                        title: 'Niepowodzenie',
                        text: 'Ten raport obejmuje więcej niż jeden dzień. Spróbuj odświeżyć stronę.',
                        color: 'danger',
                    });
                    return;
                }
                backend.updateReport(this.unfinishedReport.id, {})
                    .then(response => {
                        this.$emit('finishedReport', response.data);
                        this.$vs.notify({
                            text: this.getFinishSuccessText(response.data),
                            color: 'success',
                            time: NOTIFY_LONG_TIME,
                        });
                    })
                    .catch(error => {
                        const text = this.getErrorText(error, 'Nie udało się zakończyć raportu.');
                        this.$vs.notify({title: 'Niepowodzenie', text: text, color: 'danger'});
                    });
            },
            createReport() {
                const place = this.places.find(el => el.name === this.placeName);
                const report = {
                    'place': place.id,
                };
                backend.createReport(report)
                    .then(response => {
                        this.$emit('newReport', response.data);
                        this.$vs.notify({
                            text: this.getCreateSuccessText(response.data),
                            color: 'success',
                            time: NOTIFY_LONG_TIME,
                        });
                    })
                    .catch(error => {
                        const text = this.getErrorText(error, 'Nie udało się rozpocząć raportu.');
                        this.$vs.notify({title: 'Niepowodzenie', text: text, color: 'danger'});
                    });
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// ReportWorkButton.vue?3f7489b9